import React, { useEffect, useState } from 'react';
import axios from 'axios';
//comments
function WeeklyStandings() {
  const [leaderboardData, setLeaderboardData] = useState(null);
  const [currentNFLWeek, setCurrentNFLWeek] = useState(1);
  const [selectedWeek, setSelectedWeek] = useState(1);
  const [selectedSeasonType, setSelectedSeasonType] = useState(1);
  const [seasonYear, setSeasonYear] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [userTokens, setUserTokens] = useState(0);
  const [tokenAppliedThisWeek, setTokenAppliedThisWeek] = useState(false);
  const [leagueNumber, setLeagueNumber] = useState(null);

  useEffect(() => {
    fetchCurrentWeekInfo();
  }, []);

  useEffect(() => {
    if (selectedWeek && selectedSeasonType) {
      fetchLeaderboard(selectedWeek, selectedSeasonType);
    }
  }, [selectedWeek, selectedSeasonType]);

  useEffect(() => {
    // Fetch user profile for token balance
    const fetchUserProfile = async () => {
      const token = localStorage.getItem('token');
      if (!token) return;
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/profile`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setUserTokens(response.data.tokens || 0);
        setLeagueNumber(response.data.league_number); // <-- Added
      } catch (err) {
        setUserTokens(0);
        setLeagueNumber(null); // <-- Added
      }
    };

    // Fetch if token was applied for the current week
    const fetchTokenApplied = async () => {
      const token = localStorage.getItem('token');
      if (!token) return;
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/my-picks-results?week=${currentNFLWeek}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        // Assume response.data contains an array of picks, each with a useToken property
        setTokenAppliedThisWeek(
          response.data.some(pick => pick.useToken === true)
        );
      } catch (err) {
        setTokenAppliedThisWeek(false);
      }
    };

    fetchUserProfile();
    fetchTokenApplied();
  }, [currentNFLWeek]);

  const fetchCurrentWeekInfo = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/nfl-schedule`); // updated
      const seasonType = response.data.seasonType || 1;
      const nflWeek = response.data.week || 1;

      setCurrentNFLWeek(nflWeek);
      setSeasonYear(response.data.year || null);

      // SET DEFAULT TO CURRENT PRESEASON WEEK
      if (seasonType === 1) {
        // Currently preseason - set to current preseason week
        setSelectedWeek(nflWeek);
        setSelectedSeasonType(1);
      } else {
        // Currently regular season - set to current regular season week
        setSelectedWeek(nflWeek);
        setSelectedSeasonType(2);
      }

    } catch (err) {
      setError('Error fetching current week info');
    }
  };

  const fetchLeaderboard = async (week, seasonType) => {
    try {
      setLoading(true);
      setError(null);
      const token = localStorage.getItem('token');

      // Create the correct week identifier for the API
      const weekIdentifier = seasonType === 1 ? `pre${week}` : week;

      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/weekly-leaderboard/${weekIdentifier}`, // updated
        {
          headers: { Authorization: `Bearer ${token}` },
          params: seasonYear ? { year: seasonYear } : {}
        }
      );
      setLeaderboardData(response.data);
      setLoading(false);
    } catch (err) {
      setError('Error loading leaderboard data');
      setLoading(false);
    }
  };

  const handleWeekChange = (e) => {
    const value = e.target.value;

    if (value.startsWith('pre')) {
      // Preseason week
      const week = parseInt(value.replace('pre', ''));
      setSelectedWeek(week);
      setSelectedSeasonType(1);
    } else {
      // Regular season week
      const week = parseInt(value);
      setSelectedWeek(week);
      setSelectedSeasonType(2);
    }
  };

  const handleRefresh = () => {
    setLoading(true);
    fetchLeaderboard(selectedWeek, selectedSeasonType);
  };

  const handleDownloadPDF = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/download-picks?format=pdf`,
        {
          responseType: 'blob' // No Authorization header needed
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'weekly_picks.pdf');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      alert('Failed to download PDF.');
    }
  };

  const getTitle = () => {
    if (selectedSeasonType === 1) {
      return `Preseason Week ${selectedWeek} Standings`;
    } else {
      return `Week ${selectedWeek} Standings`;
    }
  };

  const getCurrentWeekDropdownValue = () => {
    // Return the correct dropdown value for the current selection
    if (selectedSeasonType === 1) {
      return `pre${selectedWeek}`;
    } else {
      return selectedWeek;
    }
  };

  const generateWeekOptions = () => {
    const options = [];

    // Add preseason weeks 1-4
    for (let i = 1; i <= 4; i++) {
      options.push({
        value: `pre${i}`,
        label: `Preseason Week ${i}`
      });
    }

    // Add regular season weeks 1-18
    for (let i = 1; i <= 18; i++) {
      options.push({
        value: i,
        label: `Week ${i}`
      });
    }

    return options;
  };

  const generateBlankLeaderboard = () => {
    const blankRows = [];
    for (let i = 1; i <= 10; i++) {
      blankRows.push({
        rank: i,
        userId: null,
        username: '',
        weekWins: 0,
        weekLosses: 0,
        combinedScore: ''
      });
    }
    return blankRows;
  };

  if (error) {
    return <div>{error}</div>;
  }

  if (leagueNumber !== 1) {
    return <div></div>;
  }

  const displayData = leaderboardData?.leaderboard?.length > 0 ? leaderboardData.leaderboard : generateBlankLeaderboard();

  const jwtToken = localStorage.getItem('token');
  //const canDownloadPDF = jwtToken && (userTokens > 0 || tokenAppliedThisWeek);

  return (
    <div className="weekly-standings-table">
      <h2>{getTitle()}</h2>

      {/* Week Selection Dropdown */}
      <div>
        <label htmlFor="week-select">Select Week:</label>
        <select
          id="week-select"
          value={getCurrentWeekDropdownValue()}
          onChange={handleWeekChange}
        >
          {generateWeekOptions().map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      {/* Standings Table */}
      <table className = "t1">
        <thead>
          <tr>
            <th>Rank</th>
            <th>Username</th>
            <th>Wins</th>
            <th>Losses</th>
            <th>Combined Score</th>
          </tr>
        </thead>
        <tbody>
          {displayData.map((user, index) => (
            <tr key={user.userId || index}>
              <td>
                {user.rank === 1 && user.username && '🥇'}
                {user.rank === 2 && user.username && '🥈'}
                {user.rank === 3 && user.username && '🥉'}
                {(!user.username || user.rank > 3) && user.rank}
              </td>
              <td>{user.username || ''}</td>
              <td>{user.weekWins}</td>
              <td>{user.weekLosses}</td>
              <td>{user.combinedScore || ''}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="ws-buttons">
        <button
            className="refresh-button"
            onClick={handleRefresh}
            disabled={loading}
          >
            {loading ? 'Refreshing...' : '🔄 Refresh'}
        </button>
        <button
          className="refresh-button"
          onClick={handleDownloadPDF}
        >
          📄 GET PDF
        </button>
      </div>
    </div>
  );
}

export default WeeklyStandings;